import { render, staticRenderFns } from "./ChangeName.vue?vue&type=template&id=ce681290&scoped=true&"
import script from "./ChangeName.vue?vue&type=script&lang=js&"
export * from "./ChangeName.vue?vue&type=script&lang=js&"
import style0 from "./ChangeName.vue?vue&type=style&index=0&id=ce681290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce681290",
  null
  
)

export default component.exports